import { create } from 'zustand';

interface SurveySummary {
  id: string;
  title: string;
  status: string;
  createdAt: string;
  expiresAt: string;
  currentRespondents: number;
  maxRespondents: number;
}

interface DashboardState {
  surveys: SurveySummary[];
  selectedSurvey: Record<string, unknown> | null;
  total: number;
  loading: boolean;
  error: string | null;

  setSurveys: (surveys: SurveySummary[], total: number) => void;
  setSelectedSurvey: (survey: Record<string, unknown> | null) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useDashboardStore = create<DashboardState>((set) => ({
  surveys: [],
  selectedSurvey: null,
  total: 0,
  loading: false,
  error: null,

  setSurveys: (surveys, total) => set({ surveys, total }),

  setSelectedSurvey: (survey) => set({ selectedSurvey: survey }),

  setLoading: (loading) => set({ loading }),

  setError: (error) => set({ error }),
}));
